exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[_v-0967be28]{font-family:Montserrat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0967be28&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Product/Filter.vue
// module id = 402
// module chunks = 0